import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/mdi-v6/mdi-v6.css'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
import 'quasar/src/css/index.sass'
import '../css/app.css'
import commonComponentsMixin from './mixins/commonComponentsMixin.js'
import currentUserMixin from './mixins/currentUserMixin.js'
import dialogsMixin from './mixins/dialogsMixin.js'
import fileSizeFormatMixin from './mixins/fileSizeFormatMixin.js'
import i18n from './i18n'
import navigationMixin from './mixins/navigationMixin.js'
import quasarIconSet from 'quasar/icon-set/svg-mdi-v6'
import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { Dialog, Notify, Quasar } from 'quasar'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from '../../node_modules/ziggy-js/dist/vue.m.js'
import * as Sentry from '@sentry/vue'

createInertiaApp({
  resolve: (name) =>
    resolvePageComponent(
      `../vue/Pages/${name}.vue`,
      import.meta.glob('../vue/Pages/**/*.vue'),
    ),

  setup ({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
      environment: import.meta.env.VITE_APP_ENV,
      // integrations: [new BrowserTracing({ tracingOrigins: ["*"] })],
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.1, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['*'],
      // Session Replay
      replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })

    app
      .use(plugin)
      .use(Quasar, {
        plugins: {
          Notify,
          Dialog,
        },
        iconSet: quasarIconSet,
        config: {
          extras: [
            'material-icons',
            'fontawesome-v6',
          ],
        }, // quasar config see: https://quasar.dev/start/vite-plugin/
      })
      .use(ZiggyVue)
      .use(i18n)
      .mixin(commonComponentsMixin)
      .mixin(currentUserMixin)
      .mixin(dialogsMixin)
      .mixin(fileSizeFormatMixin)
      .mixin(navigationMixin)
      .mount(el)
  },
})
